/*
 * @Author: your name
 * @Date: 2020-11-20 14:14:47
 * @LastEditTime: 2020-11-23 10:19:24
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /saas-consumer-platform/src/fetch/api/question.js
 */
import axios from './../index';
const {
  get,
  post,
  put,
  del
} = axios;
const branchUrl = "/question"; // 快速做题入口

export function quickPaper(params) {
  return post(`${branchUrl}/v1/exercise/quick/paper/generate/${params.categoryId}/${params.subjectId}?schoolId=${params.schoolId}&clientId=${params.clientId}`);
} // 重复做题

export function repeatExercise(params) {
  return post(`${branchUrl}/v1/exercise/reexamine/paper/generate/${params.recordId}`);
} // 未登录时提交所有缓存的试题数据

export function unloginQestion(params, data) {
  return post(`${branchUrl}/v1/exercise/unlogin/sync?schoolId=${params.schoolId}&currentId=${params.currentId}`, data);
} // 未登录继续做题时提交 单个缓存试题

export function submitUnloginCache(params, data) {
  return post(`${branchUrl}/v1/exercise/unlogin/data/cache?schoolId=${params.schoolId}&clientId=${params.clientId}&recordId=${params.recordId}`, data);
} // 未登录提交试题

export function unloginSubmit(params, data) {
  return post(`${branchUrl}/v1/exercise/unlogin/submit?clientId=${params.clientId}&recordId=${params.recordId}&paperId=${params.paperId}&exerciseType=${params.exerciseType}`, data);
} // 未登录重复练习

export function unlogiAgainDoing(params, data) {
  return post(`${branchUrl}/v1/exercise/unlogin/reexamine/paper/generate?clientId=${params.clientId}`, data);
}